import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';



@Component({
  selector: 'app-website-navbar',
  templateUrl: './website-navbar.component.html',
  styleUrls: ['./website-navbar.component.css']
})
export class WebsiteNavbarComponent implements OnInit, OnDestroy {

  hideDropdown: boolean = true;

  isNavOpen: boolean = false;

  cameraSnapshotUrl: string = '';
  private cameraRefreshInterval: any;

  closeNav() {
    this.isNavOpen = false;
  }

  // Method to navigate and close the menu
  navigateAndClose(route: string) {
    this.router.navigateByUrl(route);
    this.isNavOpen = false;
  }
  constructor(private router: Router) { }

  ngOnInit() {
    this.refreshCameraSnapshot();
    this.cameraRefreshInterval = setInterval(() => this.refreshCameraSnapshot(), 3000);
  }

  ngOnDestroy() {
    if (this.cameraRefreshInterval) {
      clearInterval(this.cameraRefreshInterval);
    }
  }

  private refreshCameraSnapshot() {
    this.cameraSnapshotUrl = `${environment.apiurlcore}api/camera/snapshot/liveguffa?t=${Date.now()}`;
  }

}
